import { FaUsers } from "react-icons/fa6";

export const UserGroupIcon = ({ ...rest }) => {
  return <FaUsers {...rest} />;
};
